import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Episodes from "@/pages/Episodes";
import Seasons from "@/pages/Seasons";
import Guests from "@/pages/Guests";
import About from "@/pages/About";
import Newsletter from "@/pages/Newsletter";
import Newsletters from "@/pages/Newsletters";
import NewsletterReader from "@/pages/NewsletterReader";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-PL1808E3R6", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

function Layout() {
  const location = useLocation();
  // Newsletter reader pages render a full-screen standalone document
  const isNewsletterReader = /^\/newsletters\/[^/]+$/.test(location.pathname);

  return (
    <>
      <AnalyticsTracker />
      {!isNewsletterReader && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/seasons" element={<Seasons />} />
        <Route path="/episodes" element={<Episodes />} />
        <Route path="/guests" element={<Guests />} />
        <Route path="/about" element={<About />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/newsletters" element={<Newsletters />} />
        <Route path="/newsletters/:slug" element={<NewsletterReader />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {!isNewsletterReader && <Footer />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}

export default App;
